/** @format */

import {ApolloError} from '@apollo/client';

export const isLimitReachedError = (e: unknown): boolean =>
  e instanceof ApolloError &&
  (e.graphQLErrors[0]?.extensions?.code === 'limit_reached' || e.message.includes('limit_reached'));
